export interface Position {
    left: number;
    top: number;
}
export function getPosition(): Position {
    const sel = window.getSelection();

    if (sel && sel.rangeCount) {
        const range = sel.getRangeAt(0);
        if (range.collapsed) {
            const rect = range.getClientRects()[0];
            return {
                left: rect.left,
                top: rect.top,
            };
        }
    }

    return {
        left: -1,
        top: -1,
    };
}
